document.addEventListener("click", (e) => {
  const trigger = e.target.closest('[data-trigger="search-drawer"]');
  if (!trigger) return;

  // match din drawer transition-duration: .3s
  setTimeout(() => {
    const input = document.querySelector("#Search");
    if (input) {
      input.focus();
      input.select?.();
    }
  }, 300);
});